import axios from 'axios'
import shortid from 'shortid'
import mimetypes from 'mime-types'

let webservices = {
  jwtToken: null,

  analytics: {
    visualizationsFromCarsArray: (cars, periodicity) => postJson(`/analytics/cf/visits/fromcarsarray/${periodicity}`, {
      cars
    }),
    visualizationsFromDatesAndCar: (carId, dates) => postJson(`/analytics/cf/visits/fromCar/${carId}`, { dates })
  },

  fixtures: {
    provideFromVersionUniqueId: versionUniqueId => postJson(`/v1/fixtures/ajax/provide`, {
      versionUniqueId
    }),
    getLastVersion: () => getJson('/v1/fixtures/multipublicator/lastupdate')
  },

  search: {
    findCarsDatatable: (query, page, items) => getJson(`/v1/car/search/datatable?order[0][column]=0&order[0][dir]=desc&draw=1&start=${page}&length=${items}${query}`)
  },

  versions: {
    loadFueltypesFromMakerAndModelAndYear: (makerId, modelId, year) => postJson('/v1/version/findFueltypesByMakerAndModelAndYear', {
      makerId,
      modelId,
      year
    }),
    findUniqueVersionsByVersionAndYear: (versionId) => getJson(`/version/unique/byVersionId?versionId=${versionId}`)
  },

  extras: {
    findCharacteristicsByVersionUniqueId: versionUniqueId => getJson(`/version/characteristics/findByUniqueVersion?uniqueVersionId=${versionUniqueId}`),
    findExtrasByVersionUniqueIdGrouped: (versionUniqueId) => getJson(`/extras/byVersionUniqueIdGrouped?versionUniqueId=${versionUniqueId}`)
  },

  dealer: {
    findByDealershipId: dealershipId => getJson(`/dealeship/findByDealershipId?dealershipId=${dealershipId}`),
    findCarfactoryQuota: () => getJson(`/v1/dealer/carfactoryQuota`),
    findDealerships: () => getJson(`v1/dealer/dealerships`),
    findSocieties: () => getJson('v1/dealer/societies')
  },

  publications: {
    // publish: code => postJson('/v1/publications/publish', { code }),
    // unPublish: code => postJson('/v1/publications/unPublish', { code }),
    // reserve: (code, sourceId) => postJson('/v1/car/reserve', {code, sourceId}),
    // removeReserve: code => deleteRequest(`/v1/car/${code}/reserve`),
    // getHistory: () => getJson('/v1/publications/history')

    publish: code => postJson(`/v1/publisher/publish/${code}`),
    unPublish: code => postJson(`/v1/publisher/unPublish/${code}`),
    reserve: (code, sourceId) => postJson(`/v1/publisher/reserve`, {code, sourceId}),
    removeReserve: code => deleteRequest(`/v1/publisher/reserve/${code}`),
    getHistory: () => getJson('/v1/publications/history')
  },

  sales: {
    findActiveChannels: () => getJson('/fixtures/salechannels'),
    addSaleEntry: (saleChannel, price, priceFinanced, bank, province, saleDate, code) => postJson('/v1/sale/entry', { saleChannel, price, priceFinanced, bank, province, saleDate, code })
  },

  promotions: {
    findPromotions: () => getJson('/v1/appointment/promotion'),
    findDealershipsFromPromotionId: (promotionId) => getJson(`/v1/appointment/promotion/${promotionId}/dealership`),
    findSlotsByPromotionAndDealership: (promotionId, dealershipId) => getJson(`/appointment/promotion/${promotionId}/dealership/${dealershipId}/slot/detailed`),
    deleteReserve: (reserveId) => deleteRequest(`/v1/appointment/reserve/${reserveId}`),
    createReserve: (promotionId, dealershipId, slotTimestamp, clientData) => postJson(`/appointment/promotion/${promotionId}/dealership/${dealershipId}/slot/${slotTimestamp}`, clientData),
    getReserveStatuses: () => getJson(`/v1/appointment/reserves/status`),
    updateReserveStatus: (reserveId, reserveStatus) => postJson(`/v1/appointment/reserve/${reserveId}/status`, reserveStatus),
    getDealersByPromotionDealership: (promotionDealershipId, promotionId) => getJson(`/v1/appointment/dealership/${promotionDealershipId}/promotion/${promotionId}/dealers`),
    getPromotionLeadCampaigns: () => getJson(`/promotion/lead/sources`),
    getReserveIntencions: () => getJson(`/promotion/reserve/intencion`),
    getReserveResults: () => getJson(`/promotion/reserve/result`),
    updateReserve: (reserveId, data) => postJson(`/v1/appointment/reserve/${reserveId}/update`, data),
    updateReserveIntencionResult: (data) => postJson(`http://www.montalt.cloud/api/promotions/update`, data)
  },

  postCar: (carData, uploadProgressCallback) => new Promise(async (resolve, reject) => {
    let form = new FormData()

    if (carData.pictures.length > 0) {
      for (let k in carData.pictures) {
        if (carData.pictures.hasOwnProperty(k)) {
          let picture = carData.pictures[k]
          let fileName = `${shortid.generate()}.${mimetypes.extension(picture.type)}`
          form.append(k, picture, fileName)
        }
      }
    }

    for (let key in carData) {
      if (carData.hasOwnProperty(key)) {
        if (key === 'pictures') {
          continue
        }
        form.append(key, carData[key])
      }
    }

    let xhr = new XMLHttpRequest()

    let fakeProgress = 90
    let fakeProgressInterval = -1
    xhr.upload.onprogress = function (e) {
      let progress = ((e.loaded * 100) / e.total)
      setTimeout(function () {
        uploadProgressCallback(progress * 0.9)
      }, 500)
      if (progress === 100) {
        fakeProgressInterval = setInterval(function () {
          fakeProgress += 0.35
          uploadProgressCallback(fakeProgress)
        }, 500)
      }
    }

    xhr.addEventListener('readystatechange', function () {
      if (this.readyState === 2) {
        if (fakeProgressInterval !== -1) {
          clearInterval(fakeProgressInterval)
        }
        uploadProgressCallback(100)
      }
      if (this.readyState === 4) {
        resolve(this.responseText)
      }
    })
    xhr.addEventListener('onerror', reject)

    xhr.open('POST', `${process.env.API_ENDPOINT}/v1/car`)
    xhr.setRequestHeader('Authorization', `Bearer ${webservices.jwtToken}`)
    xhr.send(form)
  }),

  putCar: (carData, uploadProgressCallback) => new Promise(async (resolve, reject) => {
    let form = new FormData()
    let fileIndex = 0
    if (carData.pictures.length > 0) {
      carData.pictures.forEach(picture => {
        let fileName = `${shortid.generate()}.${mimetypes.extension(picture.type)}`

        if (picture.type === 'text/plain') {
          fileName = picture.name + '.txt'
        }
        form.append(fileIndex++, picture, fileName)
      })
    }

    for (let key in carData) {
      if (carData.hasOwnProperty(key)) {
        if (key === 'pictures') {
          continue
        }
        form.append(key, carData[key])
      }
    }
    let xhr = new XMLHttpRequest()
    let fakeProgress = 90
    let fakeProgressInterval = -1
    xhr.upload.onprogress = function (e) {
      let progress = ((e.loaded * 100) / e.total)
      setTimeout(function () {
        uploadProgressCallback(progress * 0.9)
      }, 500)
      if (progress === 100) {
        fakeProgressInterval = setInterval(function () {
          fakeProgress += 0.35
          uploadProgressCallback(fakeProgress)
        }, 500)
      }
    }

    xhr.addEventListener('readystatechange', function () {
      if (this.readyState === 2) {
        if (fakeProgressInterval !== -1) {
          clearInterval(fakeProgressInterval)
        }
        uploadProgressCallback(100)
      }
      if (this.readyState === 4) {
        setTimeout(function (self) {
          resolve(self.responseText)
        }, 500, this)
      }
    })
    xhr.addEventListener('onerror', reject)
    xhr.open('POST', `${process.env.API_ENDPOINT}/v1/car/${carData.code}/update`)

    xhr.setRequestHeader('Authorization', `Bearer ${webservices.jwtToken}`)

    xhr.send(form)
  })
}

const service = axios.create({
  baseURL: process.env.API_ENDPOINT,
  timeout: 60000,
  headers: {'Authorization': webservices.jwtToken}
})

let deleteRequest = path => new Promise((resolve, reject) => {
  service.delete(path, {
    headers: {Authorization: `Bearer ${webservices.jwtToken}`}
  }).then(response => {
    if (response.hasOwnProperty('data') && response.data !== null) {
      resolve(response.data)
    } else {
      reject(new Error('Null data was received from server'))
    }
  }).catch(reject)
})

let postJson = (path, body) => new Promise((resolve, reject) => {
  service.post(path, body, {
    headers: {Authorization: `Bearer ${webservices.jwtToken}`}
  }).then(response => {
    if (response.hasOwnProperty('data') && response.data !== null) {
      resolve(response.data)
    } else {
      reject(new Error('Null data was received from server'))
    }
  }).catch(reject)
})

let getJson = path => new Promise((resolve, reject) => {
  service.get(path, {
    headers: {Authorization: `Bearer ${webservices.jwtToken}`}
  }).then(response => {
    if (response.hasOwnProperty('data') && response.data !== null) {
      resolve(response.data)
    } else {
      reject(new Error('Null data was received from server'))
    }
  }).catch(reject)
})

export default webservices



// WEBPACK FOOTER //
// ./src/utils/webservice.js